import Logo from '../../assets/images/logo_ai_pitch_pal.png';

export const Screen1Welcome = () => {
  return (
    <div className="h-full flex flex-1 flex-col justify-center items-center p-6 ">
      <img src={Logo} alt="Logo" className="mx-auto mb-4 max-w-[200px]" />
    </div>
  );
};
